import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Global safety net — swallow expected AxiosError 401s so they don't surface
// as red ERROR banners in Emergent's preview overlay. 401s mean the user's
// session expired; the page's ProtectedRoute will redirect on the next render
// once /auth/session is re-checked, no error banner needed.
window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const status = reason?.response?.status;
  const msg = String(reason?.message || "");
  if (status === 401 || /status code 401/i.test(msg)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the InterQuest service worker for PWA / offline shell.
// Only in production builds — dev's webpack-dev-server breaks caching.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // One-time stale-cache nuke: any user whose browser is still holding the
    // old "iq-v1" service worker bundle will have it forcibly unregistered
    // and every cache wiped, so the next page load fetches the fresh build.
    // This runs once per browser, then leaves the new SW alone.
    const NUKE_KEY = "iq_sw_nuke_v3";
    if (!localStorage.getItem(NUKE_KEY)) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        Promise.all(regs.map((r) => r.unregister())).then(() => {
          if (window.caches) {
            caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k))));
          }
          localStorage.setItem(NUKE_KEY, "1");
          // Hard reload once so the brand-new bundle gets a clean slate.
          if (!sessionStorage.getItem("iq_sw_nuke_reloaded")) {
            sessionStorage.setItem("iq_sw_nuke_reloaded", "1");
            window.location.reload();
          }
        });
      });
      return;
    }
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => console.warn("[InterQuest] SW registration failed:", err));
  });
}
